import { render, staticRenderFns } from "./check-Agreesetting.vue?vue&type=template&id=5805d36c&scoped=true"
import script from "./check-Agreesetting.vue?vue&type=script&lang=js"
export * from "./check-Agreesetting.vue?vue&type=script&lang=js"
import style0 from "./check-Agreesetting.vue?vue&type=style&index=0&id=5805d36c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805d36c",
  null
  
)

export default component.exports